export default __webpack_public_path__ + "static/media/earn.71aa8b3b.svg";